export const iamAccountIdentity = {
  type: "string",
  minLength: 1,
  maxLength: 255
};
